var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M125.62,116.25c-.6-3.67-1.54-7.93-2.52-11.39v-.02c-5.57-19.67-20.55-35.36-40.07-41.98l-.29-.1.25-.18c9.03-6.44,14.42-16.88,14.42-27.92C97.4,15.77,82.03.4,63.13.4S28.88,15.77,28.88,34.67c0,11.02,5.38,21.44,14.39,27.88l.25.18-.29.1c-6.01,2.05-17.55,7.19-27.39,18.54-4.46,5.15-7.99,10.95-10.48,17.25-2.81,7.12-4.33,14.93-4.51,23.23-.03,1.22.44,2.38,1.31,3.26.89.91,2.12,1.43,3.39,1.43h101.16c.77-.01,1.57-.02,2.43-.02,1.13,0,2.24.01,3.3.02h.06c.93,0,1.9.02,2.8.02.76,0,1.5.01,2.21.02,4.25.06,7.33.1,8.14-2.07.02-.06.05-.11.07-.17.31-.73.88-2.09-.09-8.08ZM38.26,34.67c0-13.71,11.16-24.87,24.87-24.87s24.88,11.16,24.88,24.87-11.16,24.88-24.88,24.88-24.87-11.16-24.87-24.88ZM110.53,117.17c-.8,0-1.44,0-2.05-.01-.58,0-1.14,0-1.8,0H10.44l.03-.18c1.34-8.35,3.93-15.85,7.71-22.31,3.44-5.88,7.88-10.91,13.18-14.96,8.97-6.84,20.55-10.77,31.78-10.77.11,0,11.26-.17,23.33,5.48,7.09,3.32,13.1,7.98,17.87,13.83,5.96,7.32,9.98,16.54,11.96,27.41t.11,1.33v.17s-5.87,0-5.87,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.2ab7f684ac27fc6e914563fd1ed162a0.svg";
export { ForwardRef as ReactComponent };